export const unit = 35;
export const parameterths = 0.3;
export const noderadius = 80;
